
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as map_45embeddedIvwoKMuCGr1_R_45atg04P3Er_45HuyknBC8_2VP89em5mwMeta } from "/var/www/mysite/pages/map-embedded.vue?macro=true";
import { default as _91id_93Dv5l_qG96n0ImGhBRNugXnHmUUOYZUsGBQytQZ5_zkwMeta } from "/var/www/mysite/pages/feedback-list/[id].vue?macro=true";
import { default as _91slug_93XMWY4XmxeAMiDUjmFaMDtZ_455fnmtmkKln9LGIObxSIUMeta } from "/var/www/mysite/pages/pool/drawer/[slug].vue?macro=true";
import { default as _91networkSlug_93glpUAofpz5XbNf9SNTPHzkY8tMm2zY_GYrQMzeu40ngMeta } from "/var/www/mysite/pages/networks/[networkSlug].vue?macro=true";
import { default as _91_91pageIndex_93_936YVOHNxseiQeFwMMI15nkgLHsQRAOWErEFiwd4ccokEMeta } from "/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue?macro=true";
export default [
  {
    name: "map-embedded___cs",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___da",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___de",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___en",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___es",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___et",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___fi",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___fr",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___hu",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___it",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___lt",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___lv",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___nl",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___nb",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___nn",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___no",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___pl",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___pt",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "map-embedded___sv",
    path: "/map-embedded",
    component: () => import("/var/www/mysite/pages/map-embedded.vue")
  },
  {
    name: "feedback-list-id___cs",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___da",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___de",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___en",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___es",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___et",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___fi",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___fr",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___hu",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___it",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___lt",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___lv",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___nl",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___nb",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___nn",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___no",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___pl",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___pt",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "feedback-list-id___sv",
    path: "/feedback-list/:id()",
    component: () => import("/var/www/mysite/pages/feedback-list/[id].vue")
  },
  {
    name: "pool-drawer-slug___cs",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___da",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___de",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___en",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___es",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___et",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___fi",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___fr",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___hu",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___it",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___lt",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___lv",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___nl",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___nb",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___nn",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___no",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___pl",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___pt",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "pool-drawer-slug___sv",
    path: "/pool/drawer/:slug()",
    component: () => import("/var/www/mysite/pages/pool/drawer/[slug].vue")
  },
  {
    name: "networks-networkSlug___cs",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___da",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___de",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___en",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___es",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___et",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___fi",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___fr",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___hu",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___it",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___lt",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___lv",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___nl",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___nb",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___nn",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___no",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___pl",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___pt",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "networks-networkSlug___sv",
    path: "/networks/:networkSlug()",
    component: () => import("/var/www/mysite/pages/networks/[networkSlug].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___cs",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___da",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___de",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___en",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___es",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___et",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___fi",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___fr",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___hu",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___it",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___lt",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___lv",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___nl",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___nb",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___nn",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___no",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___pl",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___pt",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  },
  {
    name: "cities-citySlugAndCountryCode-pageIndex___sv",
    path: "/cities/:citySlugAndCountryCode()/:pageIndex?",
    component: () => import("/var/www/mysite/pages/cities/[citySlugAndCountryCode]/[[pageIndex]].vue")
  }
]